import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  ///////////////
  /// Actions ///
  ///////////////

  // Triggers form submit
  trigger(event) {
    this.element.requestSubmit();
  }
}
